import React, { Component } from "react";
import Inputmask from 'inputmask';

import LabelForm from "../../../components/LabelForm";
import InputMaskForm from "../../../components/InputMaskForm";
import InputHour from "../../../components/InputHour";
import SelectForm from "../../../components/SelectForm";
import InputForm from "../../../components/InputForm";
import { bloodBagsByHfType, equipmentsActives, lookupsOrderBy, medicalStaffOption } from "../../../libs/services";

class SangreTotal extends Component{
    constructor(props){
        super(props);
        
        this.getBloodBags = this.getBloodBags.bind(this);

        this.state = {
            staffList:[],
            arms:[],
            tubes:[{value:'0',text:'Si'}, {value:'1', text:'No'}],
            bag_flags:[{value:'1',text:'Si'}, {value:'0', text:'No'}],
            criopreserves:[{value:true,text:'Si'}, {value:false, text:'No'}],
            pickings:[{value:'TOTAL',text:'Total'}, {value:'REDUCIDA', text:'Reducida'}],
            blood_bags:[],
            balanzas:[],
        }
    }
    
    async componentDidMount(){
        this.props.onRef(this);
        var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

        var options = [];
        var response = await medicalStaffOption('mainInfo');
        if(response){
            options = [];
            response.forEach(res => {
                options.push({
                    value:res.medical_staff.id,
                    text:' '+res.medical_staff.names+' '+
                            (res.medical_staff.lastname1 ? res.medical_staff.lastname1+' ' : "")+
                            (res.medical_staff.lastname2 ? res.medical_staff.lastname2 : "")
                });
            });

            this.setState({staffList:options});
        }

        response = await lookupsOrderBy('arm_type');
        if(response){
            options = [];
            response.forEach(res => {
                options.push({
                    value:res.key,
                    text:res.name
                });
            });

            this.setState({arms:options});
            
        }

        response = await equipmentsActives('BALANZA');
        if(response){
            options = [];
            response.forEach(res => {
                options.push({
                    value:res.equipment.id,
                    text:res.equipment.name
                });
            });

            this.setState({balanzas:options});
        }
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async getBloodBags(et_id){
        var response = await bloodBagsByHfType(sessionStorage.getItem('health_facilities_id'), et_id);
        if(response){
            var options = [];
            response.forEach(res => {
                options.push({
                    id:res.blood_bag.id,
                    value:res.blood_bag.id,
                    text:res.blood_bag.name,
                    blood_component_default_id:res.blood_component_default_id,
                    expiration_days:res.blood_bag.expiration_days
                });
            });

            this.setState({blood_bags:options});
        }
    }

    render(){
        const {t} = this.props;

        return(
            <>
                <fieldset>
                    <legend>Datos Extracción</legend>
                    <div className="col-xs-12 no-padding" style={{marginTop:8}}>
                        <div className="col-xs-12 col-sm-4 no-padding">
                            <div className="col-xs-12">
                                <LabelForm text={t('content.extractions.form.date_extraction')} />
                                {this.props.error_date !== "" &&
                                    <LabelForm 
                                        text={this.props.error_date} 
                                        styles={{marginLeft:8, fontSize:11, color:'red', display:(this.props.error_date.length > 15 ? 'block' : 'unser')}} 
                                    />
                                }
                                {this.props.error_hour !== "" &&
                                    <LabelForm 
                                        text={this.props.error_hour} 
                                        styles={{marginLeft:8, fontSize:11, color:'red', display:(this.props.error_hour.length > 15 ? 'block' : 'unser')}} 
                                    />
                                }
                            </div>
                            
                            <div className="col-xs-12 col-sm-6">
                                <InputMaskForm 
                                    id="date"
                                    value={this.props.extraction.date}
                                    handleChange={this.props.handleChange}
                                    disabled={this.props.disabled}
                                    variables={{type:'obj', name:'extraction'}}
                                    class={this.props.error_date !== '' ? ' error' : ''}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <InputHour 
                                    id="hour"
                                    value={this.props.extraction.hour}
                                    disabled={this.props.disabled}
                                    handleChange={this.props.handleChange}
                                    variables={{type:'obj', name:'extraction'}}
                                    class={this.props.error_hour !== '' ? ' error' : ''}
                                />
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-6" style={{paddingRight:0}}>
                            <LabelForm text={t('content.extractions.form.medical_staff')} />
                            <SelectForm 
                                id="medical_staff_id"
                                value={this.props.extraction.medical_staff_id}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.staffList}
                                variables={{type:'obj', name:'extraction'}}
                                required
                            />
                        </div>
                        
                        {this.props.extraction.type === 'SPL' ?
                            <div className="col-xs-12 col-sm-2">
                                <LabelForm text={t('content.extractions.st.number_cells')} />
                                <InputForm 
                                    type="text"
                                    id="number_cells"
                                    value={this.props.extraction.number_cells}
                                    readonly
                                    disabled
                                />
                            </div>
                            :null
                        }
                    </div>
                    <div className="col-xs-12 no-padding">
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.form.arm')} />
                            <SelectForm 
                                id="arm"
                                value={this.props.extraction.arm}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.arms}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.form.tube')} />
                            <SelectForm 
                                id="tube"
                                value={this.props.extraction.tube}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.tubes}
                                required
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.st.bag')} />
                            <SelectForm 
                                id="bag_flag"
                                value={this.props.extraction.bag_flag}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.bag_flags}
                                required
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <LabelForm text={t('content.extractions.st.blood_bags_id')} />
                            <SelectForm 
                                id="blood_bags_id"
                                value={this.props.extraction.blood_bags_id}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.blood_bags}
                                required
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        {this.props.extraction.type !== 'ST' &&
                            <div className="col-xs-12 col-sm-2">
                                <LabelForm text="Criopreservadas" />
                                <SelectForm 
                                    id="crio_preserved"
                                    value={this.props.extraction.crio_preserved}
                                    handleChange={this.props.handleChange}
                                    disabled={this.props.disabled}
                                    options={this.state.criopreserves}
                                    variables={{type:'obj', name:'extraction'}}
                                />
                            </div>
                        }
                    </div>
                    <div className="col-xs-12 no-padding">
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.st.duration')} />
                            <InputForm 
                                type="number"
                                id="extraction_time"
                                value={this.props.extraction.extraction_time}
                                handleChange={this.props.handleChange}
                                required
                                disabled={this.props.disabled}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.st.volume')} />
                            <InputForm 
                                type="number"
                                id="volume"
                                value={this.props.extraction.volume}
                                handleChange={this.props.handleChange}
                                required
                                disabled={this.props.disabled}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <LabelForm text='Balanza' />
                            <SelectForm 
                                id="equipment_id"
                                value={this.props.extraction.equipment_id}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.balanzas}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.st.lote_number')} />
                            <InputForm 
                                id="lote_number" 
                                value={this.props.extraction.lote_number} 
                                handleChange={this.props.handleChange} 
                                disabled={this.props.disabled} 
                                maxLength="45"
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        {this.props.extraction.type !== 'ST' &&
                            <div className="col-xs-12 col-sm-2">
                                <LabelForm text="Cosecha" />
                                <SelectForm 
                                    id="picking"
                                    value={this.props.extraction.picking}
                                    handleChange={this.props.handleChange}
                                    disabled={this.props.disabled}
                                    options={this.state.pickings}
                                    variables={{type:'obj', name:'extraction'}}
                                />
                            </div>
                        }
                    </div>                    
                </fieldset>
            </>
        )
    }
    
}

export default SangreTotal;